// 定义Modal组件的类型
import React, {useContext} from "react";
import './PlayTipsModal.css'
import CustomPopup from "../../../components/CustomPopup";
import {ThemeContext} from "../../../providers/themeContext/theme-context.tsx";

type PlayTipModalProps = {
    isOpen: boolean;
    onClose: () => void;
};
const PlayTipModal: React.FC<PlayTipModalProps> = ({isOpen, onClose}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="tip-modal-container">
                {/*背景花纹*/}
                <img className="left-top" src={imgUrls.leftTopBgDialogUrl} alt="bg"/>
                <img className="right-bottom-icon z-index-minus-1" src={imgUrls.rightBottomBgDialogUrl} alt="bg"/>

                <div className="tip-modal-title my-roboto-medium">How to play</div>
                <img onClick={onClose} className="tip-modal-close-btn" src={imgUrls.closerBtnGreyUrl} alt="pic"/>
                <div>
                    <div className="tip-modal-content-item margin-top-16 text-center margin-left-right-auto">
                        <div className="width-248 margin-left-right-auto display-flex-row margin-top-bottom-auto">
                            <li className="my-roboto-regular">You have</li>
                            <div className="text-blue-color my-roboto-medium"> 30 mins</div>
                            <div className="my-roboto-regular"> to guess the word.</div>
                        </div>
                    </div>

                    <div className="tip-modal-content-item-middle margin-top-11 align-center ">
                        <div className="width-248 margin-left-right-auto">
                            <li className="my-roboto-regular">The colors of the letters will change</li>
                            <div className="my-roboto-regular second-text">to show if they are correct.</div>
                        </div>
                    </div>

                    <div className="tip-modal-content-item margin-top-11 align-center ">
                        <div className="width-248 display-flex-row margin-left-right-auto margin-top-bottom-auto">
                            <li className="my-roboto-regular">Every failed attempt costs you</li>
                            <div className="text-blue-color my-roboto-medium">3mins.</div>
                        </div>
                    </div>
                </div>
                <div className="examples-text my-roboto-medium">Examples</div>
                <img className="help-detail-pic" src={imgUrls.helpPicUrl} alt="pic"/>
            </div>
        </CustomPopup>
    );
};

export default PlayTipModal;